export enum GridDesignState {
    LINE = 'line',
    TILE = 'tile',
}

export enum SponsoredArticles {
  NOT_ALLOWED = 'NOT_ALLOWED',
  LOADING = 'LOADING',
  EMPTY_RESULT = 'EMPTY_RESULT',
  RESULT = 'RESULT',
}
